export const CREATE_PROPERTY_ID = "CREATE_PROPERTY_ID";
export const DESCRIPTION_FIELD_LENGTH = 500;
export const NAME_FIELD_LENGTH = 200;
export const ADDRESS_FIELD_LENGTH = 200;
export const PHONE_FIELD_LENGTH = 15;
